import statisticsRouter from './statisticsRouter';

export default statisticsRouter;
